import { createClient } from '@supabase/supabase-js';

// Initialize Supabase with your Supabase URL and anon key
const supabaseUrl = 'https://ptfcoirhsncwpeiflent.supabase.co';  // Replace with your Supabase URL
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB0ZmNvaXJoc25jd3BlaWZsZW50Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ0OTU5ODYsImV4cCI6MjA2MDA3MTk4Nn0.4MYuVZziNJClTsRhvcTzXDvPh4izOcqvw8FWcgkcxTs';  // Replace with your Supabase anon key

export const supabase = createClient(supabaseUrl, supabaseKey);
